import React from 'react';
import PropTypes from 'prop-types';
import { IconElement, TextElement } from './Icon.styled';

export const Icon = props => {
  let { name, className, text, fontSize, ...other } = props;
  return (
    <IconElement className={`icon icon-${name} ${className || ''}`} {...other}>
      <TextElement fontSize={fontSize}>{text}</TextElement>
    </IconElement>
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  getColor: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.number,
  text: PropTypes.string,
  fontSize: PropTypes.number
};

Icon.defaultProps = {
  name: 'ok',
  color: 'buttonTextColor',
  size: 8,
  text: '',
  fontSize: 2
};

export default Icon;
